var exports = {
  "q": "xe533113f--bd658a--price",
};

module.exports = exports;
